// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "button-1oK5u";
var _3 = "icon-2uOLV";
var _4 = "description-2CEC6";
export { _1 as "__esModule", _2 as "button", _3 as "icon", _4 as "description" }
export default { "__esModule": _1, "button": _2, "icon": _3, "description": _4 }
